import React from 'react'
import { ThankYouButton } from '../../utils/AppText'
import '../../assets/css/ToiawaseThankyou.css'
import { pageTitle } from '../../utils/ToiawaseText'
const ToiawaseThankYou = () => {
    document.title = pageTitle
    return (
        < div className="toiawase-input-section-inputdetails">
            <div className="card-container-inputdetails row">
                <div id="popup_container" style={{ textAlign: 'left' }}>
                    <h1 className="h1Style01">お問い合わせ</h1>
                    <p className="txtC tm50 bm50">&nbsp;お問い合わせを承りました。<br></br>お問い合わせ内容を確認後、担当者よりご回答いたします。</p>
                </div>
            </div>
                <div className="d-grid">
                    <button type="button" className="btn btn-secondary" style={{ background: '#ffc709', color: '#333333', margin: '20% auto 45%' }}><a href='https://www.metlife.co.jp/' style={{ color: 'black', textDecoration: 'none' }}>{ThankYouButton}</a></button>
                </div>
        </div >
    )
}

export default ToiawaseThankYou
